import { TableHeaderColumnType } from '../../../../components/Table/TableHeader.component';

export const TABLE_HEADER_COLUMNS: TableHeaderColumnType[] = [
  {
    title: 'Full Name',
    dataProperty: 'full_name',
    sortable: true,
    sort: 'asc',
  },
  {
    title: 'Status',
    dataProperty: 'status',
    sortable: false,
  },
  {
    title: 'Phone',
    dataProperty: 'phone',
    sortable: false,
  },
  {
    title: 'Email',
    dataProperty: 'email',
    sortable: false,
  },
  {
    title: 'TELEGRAM',
    dataProperty: 'telegram',
    sortable: false,
  },
];
